// extracted by mini-css-extract-plugin
module.exports = {"cardOuter":"_2MH7u","heading":"_2kwdO","carCount":"_3FXGy","imageWrapper":"_2vn6A"};